export default __webpack_public_path__ + "static/media/main.21dd95f5.png";